import { LitElement, html, svg } from 'lit';

export class IconAds24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Ark med bilde og overskrift</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 6H6v5h12V6ZM6 16h12"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.5 2h17A1.5 1.5 0 0 1 22 3.5v17a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 20.5v-17A1.5 1.5 0 0 1 3.5 2Z"></path></svg>`; }
}
if (!customElements.get('f-icon-ads24', IconAds24)) {
  customElements.define('f-icon-ads24', IconAds24);
}